<template>
  <div class="container-sidebar">
    <!--上方的标题-->
    <div class="container-sidebar-title">
      <!--外部容器只为垂直居中-->
      <div class="container-sidebar-title__content">
        <span> 监测管理 </span>
      </div>
    </div>
    <!--菜单栏-->
    <a-menu class="container-sidebar-content" :open-keys.sync="menus.open" v-model:selectedKeys="menus.selected" mode="inline" @click="handleClick">
      <!--循环遍历生成所需的菜单栏-->
      <template v-for="menu in menus.list">
        <!--折叠菜单，如果存在子节点，展示折叠菜单-->
        <a-sub-menu v-if="menu.children && menu.children.length > 0" :key="menu.path">
          <!--菜单组的标题-->
          <span slot="title">{{ menu.name }}</span>
          <!--菜单组的子菜单-->
          <a-menu-item v-for="item in menu.children" :key="item.path">
            <span>
              {{ item.name }}
            </span>
          </a-menu-item>
        </a-sub-menu>
        <!--如果不存在子节点展示菜单-->
        <a-menu-item v-else :key="menu.path">
          <span>
            {{ menu.name }}
          </span>
        </a-menu-item>
      </template>
    </a-menu>
    <!--下方的不知道是什么，高度44px,带有上边框-->
    <div class="container-sidebar-footer"></div>
  </div>
</template>

<script>
import { getMenus } from '../config';
import { getRouteInfo } from '../config';

export default {
  name: 'LayoutSidebar',
  data() {
    return {
      // 菜单的相关配置
      menus: {
        list: [], // 展示数组
        open: [], // 当前展开的菜单
        selected: [], // 当前选中的菜单
      },
    };
  },
  created() {
    const menu = getRouteInfo(this.$route.fullPath);
    this.menus = {
      list: getMenus(),
      open: [menu.ppath],
      selected: [this.$route.fullPath],
    };
  },
  methods: {
    // 菜单的点击事件
    handleClick({ key: path }) {
      this.$router.push(path);
    },
  },
  watch: {
    // 监听路由，路由变换时，切换对应的菜单选择
    $route: {
      handler(val) {
        this.menus.selected = [this.$route.fullPath];
      },
      immediate: false,
    },
  },
};
</script>

<style lang="scss" scoped>
// 菜单内的菜单名称颜色--高亮
$menu-color-emphasis: rgb(36, 113, 210);
// 菜单内的菜单名称颜色--正常
$menu-color-normal: rgba(21, 40, 77, 0.85);
// 高亮状态下的背景颜色
$menu-background-emphasis: rgba(36, 113, 210, 0.09);
// 菜单头部的标题颜色
$menu-title-color: rgba(12, 83, 174, 0.85);
// 菜单头部的下边框颜色
$menu-title-border-color: rgba(12, 83, 174, 0.15);
// 菜单底部的上边框颜色
$sidebar-footer-border-color: rgba(133, 198, 255, 0.25);
// 菜单底部的文字颜色
$sidebar-footer-font-color: rgb(133, 198, 255);

// 侧边栏
.container-sidebar {
  color: $menu-color-normal;
  // 侧边栏的标题
  .container-sidebar-title {
    height: 84px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: rgba(12, 83, 174, 0.85);
    padding: 0 15px;
    .container-sidebar-title__content {
      position: relative;
      height: 42px;
      width: 100%;
      line-height: 1;
      text-align: center;
      border: {
        bottom: 1px solid $menu-title-border-color;
      }
      // 前侧的图标
      &::before {
        position: absolute;
        left: 4px;
        top: 2px;
        content: '';
        width: 14px;
        height: 14px;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAMAAADyHTlpAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURQxTrhBUsQxUrwxTryxmxQxUrw9Xs0dwTAxTrwxTrw5UsAxUrg1TsAxWtg1UrgxUrwxTriBgvwxUrw1Trw1Vrzn0DsYAAAAVdFJOU/8vi6UF9R8AxOBYum8TnujSCH3aPlNfzXQAAAHKSURBVDjLlVVZloQgDAwgm6gt7dz/rFOYoNitzsiPT6wklcoi+eNRb5MWa5dk3urjEx1wOlJzolYXUDcJIr0oic3kTqCdtuyo8z7gtlN6wYXV3Sd0DLgPP/wS5PZnvRyPUIWAsa/2YYvVl3vVQhWCp9F/Q/2YQELt0BG2U+fPoL4DiThWaHmbGlXcTHviA+Fr6ASqEb36zH0qSpBNfWbk0IGDZqizEkHSmM2LzMxpArnys26FQnnJPRvo6JirQyyzIuFgJUhegYogEwW3p6Xgeah5kgIU1qK8IZNbBQb4lVoUtuQjReFJIbdiIXqo1BaASHF6CB+ta3UtPJ2NLA1CK3oXGuxUtyXgjLS4BYM3GSI2TLvugErujhLXDLQpVap23qoV4UJyny0/I4CL2LmabSkJwvmqipOYC1l6hXJmioHPOgD7y7w+XwBa+uexFwQ23VoC52ltYrRpQax8Ila1kpi5iHVVAi9V4hKoUoLLwjLtmPfCXrcLrLd2KaC7JkSnH5vwsrVdoJQPrd0OzNQOjK1BtoG5HUMva0LG8Ha4SwPuw32/MlaC28q4X0RTu4ierLcnS/PJKv5e8Jn/IScL/slv49HP6K9f3C8TfiqbpK4mpQAAAABJRU5ErkJggg==);
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
  }
  // 侧边栏的内容
  .container-sidebar-content {
    border: 0;
    background: transparent;
    height: calc(100vh - 200px);
    overflow: {
      x: hidden;
      y: auto;
    }
    // 父菜单
    /deep/ .ant-menu-submenu-title {
      color: $menu-color-emphasis;
      margin: 4px 0;
      height: 48px;
      line-height: 48px;
      width: 100% !important;
      span {
        margin-left: 12px;
      }
      .ant-menu-submenu-arrow {
        &::before,
        &::after {
          background: $sidebar-footer-font-color;
        }
      }
    }
    // 子菜单
    /deep/ .ant-menu {
      background: transparent;
      .ant-menu-item {
        color: $menu-color-normal;
        height: 48px;
        line-height: 48px;
        width: 100% !important;
        span {
          position: relative;
          margin-left: 12px;
          &::after {
            content: '';
            position: absolute;
            left: -16px;
            top: 6px;
            width: 6px;
            height: 6px;
            border: 2px solid rgba(36, 113, 210, 0.25);
            border-radius: 50%;
          }
        }
        &.ant-menu-item-selected {
          color: $menu-color-emphasis;
          background: $menu-background-emphasis;
          &::before {
            content: '';
            position: absolute;
            top: 0px;
            right: 1px;
            height: 100%;
            width: 3px;
            box-shadow: rgba(0, 0, 0, 0.09) -2px 0px 1px 0px;
            background-color: $menu-color-emphasis;
          }
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            border-right: 3px solid #6c9ae0;
            -webkit-transform: scaleY(0.0001);
            -ms-transform: scaleY(0.0001);
            transform: scaleY(0.0001);
            opacity: 0;
            transition: opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), -webkit-transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
            transition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
            content: '';
          }
          span {
            &::after {
              border-color: $menu-color-emphasis;
            }
          }
        }
      }
    }

    // 滚动条的样式
    &::-webkit-scrollbar,
    &::-webkit-scrollbar-thumb,
    &::-webkit-scrollbar-track {
      display: none;
    }
  }

  // 下方的不知道是什么，高度44px,带有上边框
  .container-sidebar-footer {
    height: 44px;
    width: 100%;
    border: {
      top: 1px solid $sidebar-footer-border-color;
    }
    color: $sidebar-footer-font-color;
    position: absolute;
    bottom: 0;
  }
}
</style>
